import { apiFetch } from '../auth/apiFetch.ts';
import { useQuery } from '@tanstack/react-query';

// The signed-in operator, for the header badge. Served by GET /api/auth/me,
// which reads the IAP-verified identity (or null in local dev without IAP).
export interface AuthUser {
  email: string;
  tenant: string;
  role: string;
  avatar_url: string;
}

async function fetchMe(): Promise<{ user: AuthUser | null }> {
  const r = await apiFetch('/api/auth/me');
  if (!r.ok) return { user: null };
  return (await r.json()) as { user: AuthUser | null };
}

export function useAuth() {
  return useQuery({
    queryKey: ['auth', 'me'] as const,
    queryFn: fetchMe,
    // Identity is stable for the session — no need to refetch.
    staleTime: 24 * 60 * 60_000,
    retry: false,
  });
}
